import cuckoo from "../cuckoo/cuckoo"
import { cuckooEvents } from "../../consts/enums"

/*
 try/catch block is important when we disable a currency,
 in which there are already some bookings
*/

const formatThousands = (price, separator) => {
  const { length } = price
  if (length <= 3) {
    return price
  }
  const start = price.slice(0, length - 3)
  const end = price.slice(length - 3)
  return formatThousands(start, separator) + separator + end
}

// Return number of decimal places of num:string
function decimalPlaces(num) {
  const { 1: right } = num.split(".")
  return right ? right.length : 0
}

function formatPriceThousandsAndDecimals(price, langInfo) {
  const { decimalSeparator } = langInfo
  const thousandsSeparator =
    langInfo.thousandsSeparator === "nbsp" ? " " : langInfo.thousandsSeparator
  const separateFourDigits = langInfo.separateFourDigits === "1"

  const numOfDecimalPlaces = decimalPlaces(price.toString())

  // Price can also be negative. E.g. promocode
  const priceStr = Math.abs(price).toFixed(numOfDecimalPlaces)

  const [full, decimal] = priceStr.split(".")
  let formattedFull = price < 0 ? "-" : ""

  // Some languages do not separate 4 digits price. Like $3452 but $11.232 is still separated
  if (full.length === 4 && !separateFourDigits) {
    formattedFull += full
  } else {
    formattedFull += formatThousands(full, thousandsSeparator)
  }

  return decimal ? formattedFull + decimalSeparator + decimal : formattedFull
}

export function getSymbol(currencyCode, currencies) {
  try {
    return currencies[currencyCode.toLowerCase()].format.replace("__price__", "").trim()
  } catch (err) {
    cuckoo.error(cuckooEvents.GENERAL_UNSUPPORTED_CURRENCY, { currency: currencyCode })
    return currencyCode
  }
}

function getFormattedPrice(opts) {
  const { currencyCode, currencies, price } = opts
  try {
    return currencies[currencyCode.toLowerCase()].format.replace("__price__", price)
  } catch (err) {
    cuckoo.error(cuckooEvents.GENERAL_UNSUPPORTED_CURRENCY, { currency: currencyCode })
    return `${price} ${currencyCode}`
  }
}

export function formatPrice(opts) {
  const { langInfo, formatThousandsAndDecimals } = opts
  let { price } = opts

  if (formatThousandsAndDecimals) {
    price = formatPriceThousandsAndDecimals(price, langInfo)
  }

  return getFormattedPrice({ ...opts, price })
}

export function formatSeparatePrice(opts) {
  const { langInfo, formatThousandsAndDecimals } = opts
  let { price } = opts

  if (formatThousandsAndDecimals) {
    price = formatPriceThousandsAndDecimals(price, langInfo)
  }
  const separatePrice = `<span class='price-value'>${price}</span>`

  return getFormattedPrice({ ...opts, price: separatePrice })
}

export function formatISO4217Price(opts) {
  const { langInfo, formatThousandsAndDecimals } = opts
  let { price } = opts
  const { currencyCode } = opts

  if (formatThousandsAndDecimals) {
    price = formatPriceThousandsAndDecimals(price, langInfo)
  }

  return `${currencyCode.toUpperCase()} ${price}`
}

export function getCurrencyName(currencyCode, currencies) {
  try {
    return currencies[currencyCode].name
  } catch (err) {
    cuckoo.error(cuckooEvents.GENERAL_UNSUPPORTED_CURRENCY, { currency: currencyCode })
    return currencyCode
  }
}
